import { Component, inject, OnInit } from '@angular/core';
import {ModalDismissReasons, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { ToolsService } from 'src/app/services/tools.service';
import { CONFIG_URLS_API } from 'src/environments/config-envs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-modal-ajuda',
  templateUrl: './modal-ajuda.component.html',
  styleUrls: ['./modal-ajuda.component.scss']
})
export class ModalAjudaComponent implements OnInit {
  closeResult = '';
  private localStorageService = inject(LocalStorageService);
  private toolsService = inject(ToolsService<any>);
 postotemPermissaoUplodCsv = false;

  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {
   var userGuid = this.localStorageService.getItem('guid');
   var url = `${environment.host_ctf_service}${CONFIG_URLS_API.API_PostoAutorizadoUploadCsv}?guid=${userGuid}`;
   
   this.toolsService.get(url)
    .then((data: any) => {
      this.postotemPermissaoUplodCsv = data.retorno;
    });
  }



  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  open(content: any) {
    this.modalService.open(content, { windowClass: 'custom-window-class', ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      },
    );
  }
}
